import React from "react";
import { useIntl } from "react-intl";
import type { NigeriaDailyOutpatientRegisterRecord } from "../../../../../__generated__/base.gql";
import { isDefined } from "../../../_lib/is-defined";
import { RegisterTable } from "../../../_lib/register-table";
import useTimeZone from "../../../_lib/use-time-zone";
import type { NigeriaDailyOutpatientRegisterQuery } from "../__generated__/page.gql";
import { createRowFormatter } from "./createRowFormatter";
import { getViewColumns } from "./get-view-columns";

export const NigeriaDailyOutpatientRegisterTable = ({
  currentPage,
  setCurrentPage,
  loading,
  data,
}: {
  currentPage: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  loading: boolean;
  data?: NigeriaDailyOutpatientRegisterQuery;
}) => {
  const { formatMessage } = useIntl();
  const timeZone = useTimeZone();
  const rowFormatter = createRowFormatter(timeZone, formatMessage);

  return (
    <RegisterTable
      errorBoundaryName="nigeria-daily-outpatient-register-table"
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      loading={loading}
      columns={getViewColumns(formatMessage)}
      rows={
        data?.nigeriaDailyOutpatientRegister?.records
          ?.filter(isDefined)
          .map((e) =>
            rowFormatter(e as NigeriaDailyOutpatientRegisterRecord),
          ) || []
      }
      totalRows={data?.nigeriaDailyOutpatientRegister?.total ?? 0}
    />
  );
};
